var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcChevRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49408 16.4229C6.16864 16.0975 6.16864 15.5698 6.49408 15.2444L11.7382 10.0003L6.49408 4.75625C6.16864 4.43081 6.16864 3.90317 6.49408 3.57774C6.81951 3.2523 7.34715 3.2523 7.67259 3.57774L13.5059 9.41107C13.8314 9.73651 13.8314 10.2641 13.5059 10.5896L7.67259 16.4229C7.34715 16.7484 6.81951 16.7484 6.49408 16.4229Z",
    fill: "#97A2B6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChevRight);
export default __webpack_public_path__ + "static/media/ic-chev-right.fd9acaf486a10436593dba1c3e6654a5.svg";
export { ForwardRef as ReactComponent };